/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Permissions_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update permissions: {error}" |
*
* @param {Explorer_Info_Permissions_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_failed_toast = /** @type {((inputs: Explorer_Info_Permissions_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la mise a jour des autorisations : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Berechtigungen konnten nicht aktualisiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiornare le autorizzazioni: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обновить права доступа: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al actualizar los permisos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更新权限失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`権限の更新に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुमतियों को अपडेट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao atualizar as permissões: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update permissions: ${i?.error}`)
});